import { render, staticRenderFns } from "./ProductCategoryProperty.vue?vue&type=template&id=34e5676b&scoped=true&"
import script from "./ProductCategoryProperty.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e5676b",
  null
  
)

export default component.exports